enum Status {
  Active = 1,
  Closed = 2,
  Provisional = 3,
  Withdrawn = 4
}

enum Type {
  CommunityBased = 1,
  HospitalBased = 2
}

enum Address {
  Centre = 1,
  Coordinator = 2
}

enum HistoryActionType {
  Creation = 1,
  Termination = 2,
  Activation = 3
}

export const trainingCenterEnums = { Status, Type, Address, HistoryActionType }
